actioncable = require('actioncable')

class global.ActionCable

  @connect: ->
    return @cable if @cable
    return if !Session.current_user?.authentication_token || !Session.current_user.email
    @cable = actioncable.createConsumer(@url())

  @url: ->
    protocol = if process.env.API_WEB_PROTOCOL == 'https' then 'wss://' else 'ws://'
    path = "/cable?token=#{Session.current_user.authentication_token}&email=#{Session.current_user.email}"
    url = protocol + process.env.API_HOST + path



// WEBPACK FOOTER //
// ./src/libraries/action_cable.coffee